import React, { useState } from 'react';
import { UserFilters } from '../../../types';
import { UserList } from './UserList';
import { PageHeader } from '@kioskgaming/ui';

const UsersManagement: React.FC = () => {
  const [filters, setFilters] = useState<UserFilters>({
    page: 1,
    limit: 10,
    search: '',
    status: undefined,
    sortBy: 'created_at',
    sortOrder: 'DESC',
  });

  return (
    <div className="space-y-6">
      <PageHeader
        title="Player management"
        description="View kiosk players, agent and shop assignment, and account status"
      />

      {/* User List */}
      <UserList
        filters={filters}
        setFilters={setFilters}
      />
    </div>
  );
};

export default UsersManagement;